<template>
  <div>
    <div class="form-group form-group-border-bottom align-items-center d-flex flex-row position-relative" dir="rtl">
      <input type="text" :value="field.text.carrier_delivery.text" class="form-control-plaintext" list="datalistOptions" :id="name" :name="name" :placeholder="field.text.carrier_delivery.default_text" style="padding-right:42px;" :disabled="isDisabled" :aria-describedby="cityDescribedBy" :aria-invalid="cityAriaInvalid" :aria-required="fieldAriaRequired">
      <SvgImage :src="field.icon" class="position-absolute" style="right:22px; height:20px;" aria-hidden="true" />
      <datalist id="datalistOptions" dir="rtl" style="text-align:right;">
        <option v-for="opt in options" :value="opt" :key="opt"></option>
      </datalist>
    </div>
    <div v-if="isDisabled" class="invalid-feedback" :id="`${name}invalid`">{{field.disabled_error}}</div>
    <div v-else-if="field.error_message" class="invalid-feedback" :id="`${name}invalid`">{{field.error_message}}</div>
  </div>
</template>
<script>
import SvgImage from "@/components/generic/SvgImage";
import formFieldA11y from '@/mixins/formFieldA11y.js'

export default {
  mixins: [formFieldA11y],
  components: {
    SvgImage,
  },
  props: {
    label: String,
    type: String,
    name: String,
    selected: String,
    options: Array,
    field: Object,
    simple: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    isDisabled() {
      return this.field.is_disabled;
    },
    cityHasError() {
      return (this.isDisabled && !!this.field?.disabled_error) || !!this.field?.error_message;
    },
    cityDescribedBy() {
      if (this.cityHasError) {
        return `${this.name}invalid`;
      }
      return undefined;
    },
    cityAriaInvalid() {
      return this.cityHasError ? 'true' : undefined;
    },
  }
}
</script>
